export var LOGIN_CHANGE_LOGIN_TYPE = 'login/changeLogin';